module.exports = __webpack_public_path__ + "img/img-21.cdd8f572.png";